import React from 'react';

import styled from '@emotion/styled';
import { classNames } from '../../services/classNames';

import { icons } from '../../icons/icons';

interface IconRawSvg {
    name: string;
    className?: string;
}

export const IconRawSvg: React.FC<IconRawSvg> = ({ name, className = '' }) => {
    if (!name) {
        return null;
    }

    if (!icons || !icons[name]) {
        return null;
    }

    return (
        <StyledIcon
            className={classNames(
                'IconRawSvg',
                `IconRawSvg__${name}`,
                className,
            )}
            dangerouslySetInnerHTML={{ __html: icons[name] }}
        />
    );
};

const StyledIcon = styled.div`
    svg {
        height: auto;
        max-width: 100%;
    }
`;
